import React, { Component } from 'react';
import MainLayout from "../common/MainLayout";
import {withRouter} from "react-router";
import connect from "react-redux/es/connect/connect";
import * as pageActions from "../../actions/pages";

class Vignets extends Component {

    constructor(props) {
        super(props);
        this.state = {
            pageName: 'NUGGETS'
        };
    }


    componentDidMount() {
        fetch("config.json")
            .then(response => response.json())
            .then(data => {

                this.props.saveConfig(data);
            });
        let data = {"name" : this.state.pageName};
        this.props.setPage(data);
    }


    render() {

        return (

           <MainLayout pageName= {this.state.pageName} />

        );
    }
}


export default  withRouter(connect(null, {
    setPage : pageActions.setPage,
    saveConfig : pageActions.saveConfig,
})(Vignets));



// WEBPACK FOOTER //
// ./src/components/vignets/Vignets.js